import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const controlChartLimitCalculationFormDialogContextKey = defineAgentUiContextKey(
	"spc.controlChart.limitCalculation.formDialog",
);
